import React, { Component } from 'react';

export default class LiveTV extends Component {
    render () {
        return<div>
            Here will be some LiveTV
        </div>
    }
}